import orderManagement from '../../../services/order-management-service'

export const FETCH_ORDER = 'FETCH_ORDER'

export function fetchOrderDetail (orderId) {
  return (dispatch) => {
    return orderManagement.fetchOrder(orderId).then((order) => {
      dispatch({
        type: FETCH_ORDER,
        order: order
      })
    })
  }
}

export function fetchOrderDetailReducer (state = [], action) {
  switch (action.type) {
    case FETCH_ORDER: {
      return action.order
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/routes/OrderDetails/modules/orderDetails.js